<template lang="pug">
  .page
    section
      .text-center
        h1 LEGAL DOCUMENTS
        p Wall takes privacy, security and general best practice very seriously. Here, you can find up to date versions of our latest legal documents.
    section.pt-0
      b-container
        //b-button(:to="{name: 'help'}")
          font-awesome-icon.mr-2(icon="caret-left")
          span Help Articles
        div(v-for="item in legalItems", :key='item.title')
          h2 {{ item.title }}
          p {{ item.description }}
          a(:href="item.link", target="_blank")
            font-awesome-icon.mr-2(icon="file")
            span VIEW
          hr
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      legalItems: [
        {
          title: 'General Terms & Conditions',
          description: 'General terms and conditions which are applicable to all interactions with us',
          link: 'https://wall.res.ams3.digitaloceanspaces.com/resources/documents/legal/Wall%20Collective%20-%20Rental%20Terms%20and%20Conditions.pdf',
        },
        {
          title: 'Privacy Policy',
          description: 'How we collect, protect, process and use your data',
          link: 'https://cdn.wallcollective.co/resources/documents/legal/Wall%20Collective%20-%20Final%20Privacy%20Policy%2030-06-2021.pdf',
        },
        {
          title: 'Rental Terms And Conditions',
          description: 'The ins and outs of renting from and through our platform',
          link: 'https://cdn.wallcollective.co/resources/documents/legal/Wall%20Collective%20-%20Final%20Rental%20Terms%20and%20Conditions%2030-06-2021.pdf',
        },
        {
          title: 'Artist Submission Terms',
          description: 'Terms applicable to artists submitting their art for sale or rental through our platform',
          link: 'https://cdn.wallcollective.co/resources/documents/legal/Wall%20Collective%20-%20Final%20Artist%20Submission%20Terms%2030-06-2021.pdf',
        },
      ],
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/Legal.vue